import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMUser } from "../graphql/mutations";

export async function updateInvitedLLMUser(
  id: string,
  displayName: string,
  acceptTofS: boolean,
  acceptGDPR: boolean
): Promise<any> {
  return API.graphql(
    graphqlOperation(updateLLMUser, {
      input: {
        id: id,
        displayName: displayName,
        acceptedTermsOfService: acceptTofS,
        acceptedGDPRTerms: acceptGDPR,
        status: "active",
      },
    })
  ) as Promise<GraphQLResult<any>>;
}
